import {
  limitedReleaseByRegionConstants,
  createLimitedReleaseByRegionConstants,
  editLimitedReleaseByRegionConstants,
  addTargetLimitedReleaseByRegionConstants,
  removeTargetLimitedReleaseByRegionConstants,
  activateLimitedReleaseByRegionConstants,
  deactivateLimitedReleaseByRegionConstants,
  deleteLimitedReleaseByRegionConstants,
} from "../_redux-constants";
import { limitedReleasesRegionService } from "../../_services";
import { errorExtractor } from "../../_helpers";

function getLimitedReleaseByRegion(queryParams) {
  function getLimitedReleaseByRegionLoad() {
    return {
      type: limitedReleaseByRegionConstants.LIMITED_RELEASE_BY_REGION_LOADING,
    };
  }
  function getLimitedReleaseByRegionSuccess(data) {
    return {
      type: limitedReleaseByRegionConstants.LIMITED_RELEASE_BY_REGION_SUCCESS,
      data,
    };
  }
  function getLimitedReleaseByRegionFailure(error) {
    return {
      type: limitedReleaseByRegionConstants.LIMITED_RELEASE_BY_REGION_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(getLimitedReleaseByRegionLoad());
    return limitedReleasesRegionService
      .getLimitedReleaseByRegion(queryParams)
      .then(
        (data) => {
          dispatch(getLimitedReleaseByRegionSuccess(data));
        },
        (error) => {
          dispatch(getLimitedReleaseByRegionFailure(error?.toString()));
        }
      );
  };
}

function createLimitedReleaseByRegion(requestBody, queryParams) {
  function createLimitedReleaseByRegionLoad() {
    return {
      type: createLimitedReleaseByRegionConstants.CREATE_LIMITED_RELEASE_BY_REGION_LOADING,
    };
  }
  function createLimitedReleaseByRegionSuccess(data) {
    return {
      type: createLimitedReleaseByRegionConstants.CREATE_LIMITED_RELEASE_BY_REGION_SUCCESS,
      data,
    };
  }
  function createLimitedReleaseByRegionFailure(error) {
    return {
      type: createLimitedReleaseByRegionConstants.CREATE_LIMITED_RELEASE_BY_REGION_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(createLimitedReleaseByRegionLoad());
    return new Promise((resolve, reject) => {
      limitedReleasesRegionService
        .createLimitedReleaseByRegion(requestBody, queryParams)
        .then(
          (data) => {
            dispatch(createLimitedReleaseByRegionSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(createLimitedReleaseByRegionFailure(error?.toString()));
            errorExtractor(error, reject);
          }
        );
    });
  };
}
function editLimitedReleaseByRegion(requestBody, queryParams) {
  function editLimitedReleaseByRegionLoad() {
    return {
      type: editLimitedReleaseByRegionConstants.EDIT_LIMITED_RELEASE_BY_REGION_LOADING,
    };
  }
  function editLimitedReleaseByRegionSuccess(data) {
    return {
      type: editLimitedReleaseByRegionConstants.EDIT_LIMITED_RELEASE_BY_REGION_SUCCESS,
      data,
    };
  }
  function editLimitedReleaseByRegionFailure(error) {
    return {
      type: editLimitedReleaseByRegionConstants.EDIT_LIMITED_RELEASE_BY_REGION_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(editLimitedReleaseByRegionLoad());
    return new Promise((resolve, reject) => {
      limitedReleasesRegionService
        .editLimitedReleaseByRegion(requestBody, queryParams)
        .then(
          (data) => {
            dispatch(editLimitedReleaseByRegionSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(editLimitedReleaseByRegionFailure(error?.toString()));
            errorExtractor(error, reject);
          }
        );
    });
  };
}

function addTargetLimitedReleaseByRegion(requestBody, queryParams) {
  function addTargetLimitedReleaseByRegionLoad() {
    return {
      type: addTargetLimitedReleaseByRegionConstants.ADD_TARGET_LIMITED_RELEASE_BY_REGION_LOADING,
    };
  }
  function addTargetLimitedReleaseByRegionSuccess(data) {
    return {
      type: addTargetLimitedReleaseByRegionConstants.ADD_TARGET_LIMITED_RELEASE_BY_REGION_SUCCESS,
      data,
    };
  }
  function addTargetLimitedReleaseByRegionFailure(error) {
    return {
      type: addTargetLimitedReleaseByRegionConstants.ADD_TARGET_LIMITED_RELEASE_BY_REGION_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(addTargetLimitedReleaseByRegionLoad());
    return new Promise((resolve, reject) => {
      limitedReleasesRegionService
        .addTargetLimitedReleaseByRegion(requestBody, queryParams)
        .then(
          (data) => {
            dispatch(addTargetLimitedReleaseByRegionSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(addTargetLimitedReleaseByRegionFailure(error?.toString()));
            errorExtractor(error, reject);
          }
        );
    });
  };
}

function removeTargetLimitedReleaseByRegion(queryParams) {
  function removeTargetLimitedReleaseByRegionLoad() {
    return {
      type: removeTargetLimitedReleaseByRegionConstants.REMOVE_TARGET_LIMITED_RELEASE_BY_REGION_LOADING,
    };
  }
  function removeTargetLimitedReleaseByRegionSuccess(data) {
    return {
      type: removeTargetLimitedReleaseByRegionConstants.REMOVE_TARGET_LIMITED_RELEASE_BY_REGION_SUCCESS,
      data,
    };
  }
  function removeTargetLimitedReleaseByRegionFailure(error) {
    return {
      type: removeTargetLimitedReleaseByRegionConstants.REMOVE_TARGET_LIMITED_RELEASE_BY_REGION_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(removeTargetLimitedReleaseByRegionLoad());
    return new Promise((resolve, reject) => {
      limitedReleasesRegionService
        .removeTargetLimitedReleaseByRegion(queryParams)
        .then(
          (data) => {
            dispatch(removeTargetLimitedReleaseByRegionSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(
              removeTargetLimitedReleaseByRegionFailure(error?.toString())
            );
            errorExtractor(error, reject);
          }
        );
    });
  };
}

function activateLimitedReleaseByRegion(queryParams) {
  function activateLimitedReleaseByRegionLoad() {
    return {
      type: activateLimitedReleaseByRegionConstants.ACTIVATE_LIMITED_RELEASE_BY_REGION_LOADING,
    };
  }
  function activateLimitedReleaseByRegionSuccess(data) {
    return {
      type: activateLimitedReleaseByRegionConstants.ACTIVATE_LIMITED_RELEASE_BY_REGION_SUCCESS,
      data,
    };
  }
  function activateLimitedReleaseByRegionFailure(error) {
    return {
      type: activateLimitedReleaseByRegionConstants.ACTIVATE_LIMITED_RELEASE_BY_REGION_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(activateLimitedReleaseByRegionLoad());
    return new Promise((resolve, reject) => {
      limitedReleasesRegionService
        .activateLimitedReleaseByRegion(queryParams)
        .then(
          (data) => {
            dispatch(activateLimitedReleaseByRegionSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(activateLimitedReleaseByRegionFailure(error?.toString()));
            reject(error);
          }
        );
    });
  };
}

function deactivateLimitedReleaseByRegion(queryParams) {
  function deactivateLimitedReleaseByRegionLoad() {
    return {
      type: deactivateLimitedReleaseByRegionConstants.DEACTIVATE_LIMITED_RELEASE_BY_REGION_LOADING,
    };
  }
  function deactivateLimitedReleaseByRegionSuccess(data) {
    return {
      type: deactivateLimitedReleaseByRegionConstants.DEACTIVATE_LIMITED_RELEASE_BY_REGION_SUCCESS,
      data,
    };
  }
  function deactivateLimitedReleaseByRegionFailure(error) {
    return {
      type: deactivateLimitedReleaseByRegionConstants.DEACTIVATE_LIMITED_RELEASE_BY_REGION_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(deactivateLimitedReleaseByRegionLoad());
    return new Promise((resolve, reject) => {
      limitedReleasesRegionService
        .deactivateLimitedReleaseByRegion(queryParams)
        .then(
          (data) => {
            dispatch(deactivateLimitedReleaseByRegionSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(
              deactivateLimitedReleaseByRegionFailure(error?.toString())
            );
            errorExtractor(error, reject);
          }
        );
    });
  };
}

function deleteLimitedReleaseByRegion(queryParams) {
  function deleteLimitedReleaseByRegionLoad() {
    return {
      type: deleteLimitedReleaseByRegionConstants.DELETE_LIMITED_RELEASE_BY_REGION_LOADING,
    };
  }
  function deleteLimitedReleaseByRegionSuccess(data) {
    return {
      type: deleteLimitedReleaseByRegionConstants.DELETE_LIMITED_RELEASE_BY_REGION_SUCCESS,
      data,
    };
  }
  function deleteLimitedReleaseByRegionFailure(error) {
    return {
      type: deleteLimitedReleaseByRegionConstants.DELETE_LIMITED_RELEASE_BY_REGION_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(deleteLimitedReleaseByRegionLoad());
    return new Promise((resolve, reject) => {
      limitedReleasesRegionService
        .deleteLimitedReleaseByRegion(queryParams)
        .then(
          (data) => {
            dispatch(deleteLimitedReleaseByRegionSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(deleteLimitedReleaseByRegionFailure(error?.toString()));
            errorExtractor(error, reject);
          }
        );
    });
  };
}

export const limitedReleasesRegionActions = {
  getLimitedReleaseByRegion,
  createLimitedReleaseByRegion,
  editLimitedReleaseByRegion,
  addTargetLimitedReleaseByRegion,
  removeTargetLimitedReleaseByRegion,
  activateLimitedReleaseByRegion,
  deactivateLimitedReleaseByRegion,
  deleteLimitedReleaseByRegion,
};
